export default "__VITE_ASSET__DtyZmp0w__"